import { setState } from './helpers'

const trainingMutations = {
  SET_TRAINING: setState('training'),
  SET_TRAININGS: setState('trainings'),

  SET_B_TRAININGS: setState('bTrainings'),
  SET_B_TRAINING: setState('bTraining'),
  SET_B_TRAINING_TYPES: setState('bTrainingTypes'),
  SET_B_TRAINING_COSTS: setState('bTrainingCosts'),
  SET_B_TRAINING_DETAILS: setState('bTrainingsDetails'),

  SET_QUESTIONS: setState('questions'),
  SET_CERTIFICATE_TEXTS: setState('certificateTexts'),

  SET_TRAINING_RESULTS: setState('trainingResults'),
  SET_B_TRAINING_RESULTS: setState('bTrainingResults'),
  SET_EXTERNAL_TRAINING_RESULTS: setState('externalTrainingResults'),
  SET_HUNTER_RESULTS: setState('hunterResults'),
  SET_UBERALL_RESULTS: setState('uberallResults'),

  SET_HUNTER_DETAILS: setState('hunterDetails'),
  SET_HUNTER_DETAIL: setState('hunterDetail'),

  SET_TRAINING_FILTERS: setState('trainingFilters')
}

export { trainingMutations }
